/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListClientSecretsResponse } from '../../models/list-client-secrets-response';

export interface ListClientSecrets$Params {
  organizationId: string;
}

export function listClientSecrets(http: HttpClient, rootUrl: string, params: ListClientSecrets$Params, context?: HttpContext): Observable<StrictHttpResponse<ListClientSecretsResponse>> {
  const rb = new RequestBuilder(rootUrl, listClientSecrets.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ListClientSecretsResponse>;
    })
  );
}

listClientSecrets.PATH = '/v1/organizations/{organizationId}/clientsecrets';
